import styled from "styled-components";

const FormBody = styled("div")`
    color: #666;
    font-size: 14px;
    line-height: 1.5;
`;

export default FormBody;
